

import GenAgent from '@/components/GenAgent'

export default function AgentPage() {
    return (
        <div className="flex flex-1 flex-col overflow-hidden">
            <div className='flex justify-between items-center px-10 h-20 border-b border-secondary-foreground/10'>
                <div className='flex gap-2 items-center'>
                    <h1 className='text-2xl font-bold border-l-4 border-primary pl-4'>Kagami Agent</h1>
                </div>
            </div>
            <div className='flex flex-1 overflow-hidden'>
                <GenAgent />
            </div>
        </div>
    )
}
